import { useState, useEffect, useMemo } from "react";
import { Star } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import api from "../utils/api";
const CelebrationComponent = ({ setCompletePart, taskPackage }) => {
  const [fireworks, setFireworks] = useState([]);
  const [checkedTask, setCheckedTask] = useState(false);
  const [starSize, setStarSize] = useState(80);
  const navigator = useNavigate();
  // Redux seçicilerini optimize ettik (Sadece ihtiyacımız olanı alıyoruz)
  const completeChapterList = useSelector((state) => state.score.value);
  const mainObj = useSelector((state) => state.contents.contentValues);
  useEffect(() => {
    completeChapterList.map((item) => {
      if (item.unit === mainObj.Unites && item.chapter === mainObj.chapter) {
        setCheckedTask(true);
      }
    });
  }, [completeChapterList, mainObj]);
  //ana sayfaya geri döndürme fonksiyonu
  const handleReturn = () => {
    setCompletePart(false);
    navigator("/");
  };

  const staticSparkles = useMemo(() => {
    return Array(15)
      .fill()
      .map((_, i) => ({
        id: i,
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        duration: `${Math.random() * 2 + 0.5}s`,
        delay: `${Math.random() * 2}s`,
      }));
  }, []);

  const handleUpdateScore = async () => {
    const userString = localStorage.getItem("postUser");
    if (!userString) return;

    const user = JSON.parse(userString);
    const userId = user._id;

    if (!mainObj?.Unites || !mainObj?.chapter) {
      alert("Veri henüz yüklenmedi, lütfen bekleyin.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };

      // İlk istek: İstatistikleri kaydet
      const res = await api.post(
        "post_userstatistics",
        {
          userId: userId,
          className: mainObj,
          unit: mainObj.Unites,
          chapter: mainObj.chapter,
          taskStatistics: taskPackage,
        },
        config,
      );

      if (res.status === 200) {
        // İkinci istek: Skoru güncelle
        const resUpdate = await api.put(
          `socreUpdate?_id=${userId}`,
          {
            unit: mainObj.Unites,
            chapter: mainObj.chapter,
            completedChapter: true,
          },
          config,
        );

        if (resUpdate.status === 200) {
          setCompletePart(false);
          navigator("/");
        }
      }
    } catch (error) {
      console.error("Güncelleme hatası:", error);
      alert("Bir hata oluştu. Lütfen bağlantınızı kontrol edin.");
    }
  };

  return (
    <div className="relative w-full h-96 overflow-hidden">
      {/* Dinamik Havai Fişekler */}
      {checkedTask ? (
        <div
          className="mt-8 p-6 bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg
        text-center shadow-lg absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 w-3/4 max-w-md"
        >
          <h2 className="text-2xl font-bold text-yellow-700">Tebrikler!</h2>
          <p className="text-yellow-600 mb-2">Tüm eşleştirmeler doğru!</p>
          <p className="text-yellow-600 mb-2 font-sans">
            Daha önce bu egzersizi tamamlamışsınız!
          </p>

          <div className="flex justify-center items-center h-32">
            <Star
              size={starSize}
              className="text-yellow-500 transition-all duration-1000"
              fill="gold"
            />
          </div>

          <button
            className="mt-4 px-8 py-3 bg-yellow-500 text-white font-bold rounded-full
           hover:bg-yellow-600 transition-transform active:scale-95 shadow-md"
            onClick={handleReturn}
          >
            Ana Sayfaya Dön
          </button>
        </div>
      ) : (
        <div>
          {fireworks.map((fw) => (
            <div
              key={fw.id}
              className="absolute animate-ping"
              style={{
                left: `${fw.x}%`,
                top: `${fw.y}%`,
                width: `${fw.size}rem`,
                height: `${fw.size}rem`,
              }}
            >
              <div
                className={`w-full h-full rounded-full bg-${fw.color}-500 opacity-70`}
              />
            </div>
          ))}

          {/* Mesaj Kutusu */}
          <div
            className="mt-8 p-6 bg-gradient-to-r from-yellow-100 to-yellow-200 rounded-lg
        text-center shadow-lg absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 w-3/4 max-w-md"
          >
            <h2 className="text-2xl font-bold text-yellow-700">Tebrikler!</h2>
            <p className="text-yellow-600 mb-2">Tüm eşleştirmeler doğru!</p>

            <div className="flex justify-center items-center h-32">
              <Star
                size={starSize}
                className="text-yellow-500 transition-all duration-1000"
                fill="gold"
              />
            </div>

            <button
              className="mt-4 px-8 py-3 bg-yellow-500 text-white font-bold rounded-full
           hover:bg-yellow-600 transition-transform active:scale-95 shadow-md"
              onClick={handleUpdateScore}
            >
              Yıldız Al
            </button>
          </div>

          {/* Statik Parıltılar */}
          <div className="absolute inset-0 pointer-events-none">
            {staticSparkles.map((s) => (
              <div
                key={s.id}
                className="absolute animate-pulse text-yellow-400 text-2xl"
                style={{
                  left: s.left,
                  top: s.top,
                  animationDuration: s.duration,
                  animationDelay: s.delay,
                }}
              >
                ✨
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

// React.memo ile sarmalayarak proplar değişmedikçe render'ı önledik
export default CelebrationComponent;
